import { render } from "./FormBagsize.vue?vue&type=template&id=5082606c&scoped=true&ts=true"
import script from "./FormBagsize.vue?vue&type=script&lang=ts"
export * from "./FormBagsize.vue?vue&type=script&lang=ts"

import "./FormBagsize.vue?vue&type=style&index=0&id=5082606c&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5082606c"]])

export default __exports__